import React from 'react';
import Layout from '../components/layout/Layout';
import '../styles/CompanyPage.css';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <Layout>
      <div className="privacy-page">
        <div className="container">
          <h1 className="page-title">プライバシーポリシー</h1>

          <div className="policy-card single-card">
            <div className="policy-section">
              <h2 className="section-title">1. 事業者の名称</h2>
              <p>株式会社むつび</p>
            </div>

            <div className="policy-section">
              <h2 className="section-title">2. 代表者</h2>
              <p>代表取締役 畑迫 睦和</p>
            </div>

            <div className="policy-section">
              <h2 className="section-title">3. 収集する情報の種類</h2>
              <p>
                お問い合わせフォームで取得する氏名、メールアドレス、問い合わせ内容など。サービス提供に必要なログ情報等。
              </p>
            </div>

            <div className="policy-section">
              <h2 className="section-title">4. 利用目的</h2>
              <p>
                取得した情報はお問い合わせ対応、サービス改善、法令対応のために利用します。
              </p>
            </div>

            <div className="policy-section">
              <h2 className="section-title">5. 保管期間</h2>
              <p>法令に基づき必要な期間保存します。詳細はお問い合わせください。</p>
            </div>

            <div className="policy-section">
              <h2 className="section-title">6. 第三者提供</h2>
              <p>法令に基づく場合や、お客様の同意がある場合を除き第三者に提供しません。</p>
            </div>

            <div className="policy-section">
              <h2 className="section-title">7. お問い合わせ先</h2>
              <p>お問い合わせはサイト内のお問い合わせフォームまたは info@example.com（例）までご連絡ください。</p>
            </div>
            <p className="note">本ページは参考ページを基に作成したドラフトです。最終版は法務の確認後に確定してください。</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicyPage;
